export const getHashFile = async (file: File | null): Promise<string | null> => {
  if (file && file.name) {
    const arrayBuffer: any = await file.arrayBuffer()
    const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
    return hashHex
  }
  return null
}

export const parseTextFileName = (name: string): string => {
  if (name.length > 25) {
    const ext = name.split('.').pop()
    return `${name.substring(0, 22)}...${ext}`
  }
  return name
}
